import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BLOG_POSTS, waLink } from "../lib/data";

export default function Blog() {
  return (
    <section
      id="blog"
      data-testid="blog-section"
      className="relative bg-[#0A0B0E] py-24 lg:py-36 border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em]">
                Recursos y guías
              </span>
            </div>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Blog sobre{" "}
              <span className="italic text-[#D4AF37]">polarizado en Querétaro</span>.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-end">
            <p className="text-base text-white/55 font-light leading-relaxed">
              Artículos especializados para ayudarte a tomar la mejor decisión
              sobre película de polarizado.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5 rounded-2xl overflow-hidden border border-white/5">
          {BLOG_POSTS.map((p, i) => (
            <motion.a
              key={i}
              href={waLink(p.waMsg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`blog-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group relative bg-[#0A0B0E] hover:bg-[#14161C] p-8 lg:p-10 transition-colors min-h-[280px] flex flex-col justify-between"
            >
              <div>
                <div className="inline-block text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-5 pb-2 border-b border-[#D4AF37]/30">
                  {p.tag}
                </div>
                <h3 className="font-display text-xl lg:text-2xl text-white tracking-tight leading-tight mb-4 group-hover:text-[#D4AF37] transition-colors">
                  {p.title}
                </h3>
                <p className="text-sm text-white/50 font-light leading-relaxed">
                  {p.excerpt}
                </p>
              </div>
              <div className="mt-6 flex items-center gap-2 text-[#D4AF37] text-xs uppercase tracking-[0.25em]">
                Leer más
                <ArrowUpRight
                  size={14}
                  className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
